import React from 'react';
import './index.less';
import Ticon from '../Icon';
import ModalPage from '../ModalPage';
import RefTree from '../RefTree/RefTreeNoBackEvent';
import { qrCodeScan } from 'mutants-jsbridge';
import { tools} from 'tplus-voucher';
import { NavUtils } from 'mutants-mobile-navigator';


export default class SearchBar extends React.Component {

  constructor(props) {
    super(props);
    this.searchKey = this.props.searchKey ? this.props.searchKey : '';
    this.state = {
      value: props.defaultValue || '',
      isInput: false,
      visible: false
    };
  }


  static defaultProps = {
    // groupClick: () => {},
    placeholder: ''
  }

  onChange = (e) => {
    this.setState({
      value: e.target.value
    });
    const {
      onChange,
    } = this.props;
    if (onChange) {
      onChange(e.target.value);
    }
  }

  clear = () => {
    this.setState({
      value: ''
    });
    const {
      onChange,
    } = this.props;
    if (onChange) {
      onChange('');
    }
  }

  scanQRCode = async () => {
    let isCloseAlert = tools.getLocalCache('isCloseAlert');
    // let resultConfirm = true
    // if (isCloseAlert == 'true') {
    //   resultConfirm = false
    // }
    let resultConfirm = false
    if (isCloseAlert == 'false') {
      resultConfirm = true
    }
    if (!qrCodeScan) {
      return;
    }
    const qrCode = await qrCodeScan(resultConfirm);
    this.scanSuccess(qrCode);
  }

  scanSuccess = (qrCode) => {
    this.setState({
      value: qrCode
    })

    const {onChange,onScan} = this.props;
    if(onScan){
      onScan(qrCode);
      return;
    }
    if (onChange) {
      onChange(qrCode);
    }
  }


  groupClick = () => {
    this.setState({
      visible: true
    })
    console.log('弹出 dtoName', this.props.dtoName);
  }

  groupClose = () => {
    this.setState({
      visible: false
    })
  }

  groupCallBack = id => {
    this.props.groupCallBack && this.props.groupCallBack(id);
    this.groupClose();
  }

  onClick = () => {
    this.props.onFocus && this.props.onFocus();
    setTimeout(() => {
      this.input.focus();
    }, 500)
  }

  onOptionItemClick = (opt) => {
    const { optionItemClick } = this.props;
    if (optionItemClick) {
      optionItemClick(opt);
    }
  }

  getOptTitle = (opt) => {
    return opt.displayValue;
  }

  componentDidMount(){
    if(this.input){
      this.input.addEventListener('keydown', this.keydown)
    }
  }

  keydown = (event) => {
    if (event.keyCode == 13) {
      if(this.props.options && this.props.options.length>0){
        this.onOptionItemClick(this.props.options[0]);
      }else{
        const {onChange,onScan} = this.props;
        if(onScan){
          //若是扫描出来的 只搜出一条的情况下 自动回填
          onScan(this.state.value);
          return;
        }
        if (onChange) {
          onChange(this.state.value);
        }
      }
    }
  }

  render() {
    const {
      placeholder,
      dtoName,
      children,
      value,
      groupActived,
      groupSeleted,
      onFocus,
      realInput,
      isFixedClassify,
      hideReviseBtn = false,
      classifyItem,
      chooseCallback,
      options = [],
      showSetBtn = true
    } = this.props;
    let { visible } = this.state;
    const treeStyle = visible ? {} : { display: 'none' }
    let isQuicksearch = tools.getLocalCache('isQuicksearch');
    return (
      <div className='searchBar'>
        {
          dtoName ?
            <div className={`group ${groupActived ? 'actived' : ''}`} onClick={this.groupClick}>
              分类
              <Ticon type='zhankaitubiao1' className={`zhankai-icon ${groupActived ? 'actived' : ''}`} />
            </div>
            :
            null
        }

        <div className='search-bar'>
          <Ticon type='sousuo-new' className='sousuo-icon' />
          {realInput === true && <input ref={ref => {this.input = ref}}type='text' onChange={this.onChange} value={value} placeholder={placeholder} onFocus={onFocus} />}
          {realInput === undefined && <input ref={ref => {this.input = ref}} type='text' onChange={this.onChange} value={value} placeholder={placeholder} onFocus={onFocus} />}
          {realInput === false && <div ref={ref => {this.input = ref}} style={{ width: '3rem', height: '0.3rem', lineHeight: '0.3rem', textAlign: 'left', color: '#CCC' }} onClick={this.onClick} >{placeholder}</div>}
          {
            value && <Ticon type='shanchu1' onClick={this.clear} className='sousuo-icon shanchu1-icon' />
          }
        </div>
        {
          children ?
            children
            :
            null
        }
        <Ticon type='saoyisao' className='saoyisao-icon' onClick={this.scanQRCode} />
        <div className='reftree' style={treeStyle}>
        {/* groupJump={groupJump}  */}
          <RefTree showSetBtn = {showSetBtn} dtoName={dtoName} navLeftClick={this.groupClose} groupCallBack={this.groupCallBack} groupSeleted={groupSeleted} classifyItem={classifyItem} hideReviseBtn ={hideReviseBtn} isFixedClassify={isFixedClassify} chooseCallback={chooseCallback}/>
        </div>
        <ul className={(isQuicksearch == 'true'|| tools.isEmpty(isQuicksearch)) && options.length > 0 ? 'options_visible' : 'options'}>
          {options.map((opt) => {
            return <li className={'option_item'} onClick={() => this.onOptionItemClick(opt)} title={this.getOptTitle(opt)}>
              {opt.displayValue}
            </li>
          })}
        </ul>
      </div>
    )
  }

}
